export const ZODIAC_GLYPH = {
  Aries: "♈\uFE0E", Taurus: "♉\uFE0E", Gemini: "♊\uFE0E", Cancer: "♋\uFE0E", Leo: "♌\uFE0E", Virgo: "♍\uFE0E",
  Libra: "♎\uFE0E", Scorpio: "♏\uFE0E", Sagittarius: "♐\uFE0E", Capricorn: "♑\uFE0E", Aquarius: "♒\uFE0E", Pisces: "♓\uFE0E",
};

export const messagesUrl = (kind, id) => {
  if (kind === "hub") return `/hubs/${encodeURIComponent(id)}/messages`;
  if (kind === "group") return `/groups/${id}/messages`;
  return `/dms/${id}/messages`;
};

export const avatarSrc = (avatar) => (avatar.startsWith("http") ? avatar : `${process.env.REACT_APP_BACKEND_URL}${avatar}`);
